import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';

@Injectable({ providedIn: 'root' })
export class ShipTransactionsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    getShipDetails(id: number) {
        return this.http.get<any[]>(this._url(`/stockpackdetails/${id}`));
    }

    createShip(model: any) {
        return this.client.post<string>(this._url(), model);
    }

    updateShip(id: number, model: any) {
        return this.client.put(this._url(`/${id}`), model);
    }

    getShipHistories(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<any[]>(this._url(`/grid-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
    }

    getUrl() {
        return this._url();
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/ShipTransactions${v}`);
    }
}
